import RU from '../assets/country/ru.svg'
import AU from '../assets/country/au.svg'
import BR from '../assets/country/br.svg'
import CA from '../assets/country/ca.svg'
import CH from '../assets/country/ch.svg'
import BL from '../assets/country/bl.svg'
import UA from '../assets/country/ua.svg'
import US from '../assets/country/us.svg'
import JP from '../assets/country/jp.svg'


export const popular = [
    {
        svg: RU,
        country: 'RUS',
        city: 'Moscow',
    },
    {
        svg: AU,
        country: 'AUS',
        city: 'Sydney',
    },
    {
        svg: BR,
        country: 'BRZ',
        city: 'Rio de Janeiro',
    },
    {
        svg: CA,
        country: 'CND',
        city: 'Toronto',
    },
    {
        svg: CH,
        country: 'SWZ',
        city: 'Zurich',
    },
    {
        svg: BL,
        country: 'FRC',
        city: 'Paris',
    },
    {
        svg: UA,
        country: 'UKR',
        city: 'Kiev',
    },
    {
        svg: US,
        country: 'USA',
        city: 'Washington',
    },{
        svg: JP,
        country: 'JPN',
        city: 'Tokyo',
    },
]